import { forwardRef } from "react";
import styles from "./custom-button.module.scss";

const cx = (...xs) => xs.filter(Boolean).join(" ");

const CustomButton = forwardRef(
	(
		{
			as = "button",
			variant = "primary",
			size = "md",
			block = false,
			loading = false,
			disabled = false,
			startIcon,
			endIcon,
			children,
			className,
			type = "button",
			href,
			onClick,
			form,
			ariaLabel,
			style,
			...rest
		},
		ref,
	) => {
		const classes = cx(styles.btn, styles[variant], styles[size], block && styles.block, loading && styles.loading, className);

		const content = (
			<>
				{loading ? <span className={styles.spinner} aria-hidden="true" /> : startIcon ? <span className={styles.icon}>{startIcon}</span> : null}
				{children ? <span className={styles.label}>{children}</span> : null}
				{endIcon && !loading ? <span className={styles.icon}>{endIcon}</span> : null}
			</>
		);

		if (as === "a" || href) {
			return (
				<a ref={ref} href={href} className={classes} aria-label={ariaLabel} style={style} {...rest}>
					{content}
				</a>
			);
		}

		return (
			<button
				ref={ref}
				type={type}
				className={classes}
				disabled={disabled || loading}
				onClick={onClick}
				form={form}
				aria-label={ariaLabel}
				aria-busy={loading || undefined}
				style={style}
				{...rest}
			>
				{content}
			</button>
		);
	},
);

CustomButton.displayName = "CustomButton";

export default CustomButton;
